import React, { PureComponent } from "react";

import { appAction } from '../store/app';
import { $catch } from "../utils";
import Config from '../config';



/**
 * 路由认证
 * @param Component
 */
const AuthentRouter = (Component) => {
    return (props) => (
        <AuthentComponent {...props}>
            <React.Suspense fallback={<div>Loading...</div>}>
                <Component {...props} />
            </React.Suspense>
        </AuthentComponent>
    )
}



class AuthentComponent extends PureComponent {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
    }

    render() {
        const { route, history } = this.props;
        if (route.meta.auth) {
            //是否有token
            const isLogin = $catch.getSessionItem(Config.headers[0]);
            if (!isLogin) {
                history.push('/login');
                return null;
            }
        }

        //写入路由元数据到状态
        appAction.routerMetaData_seg(route.meta);
        return this.props.children;
    }
}


export default AuthentRouter;
